import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { RiskScore } from '../../model/finzy-flex/product-list.model';

@Component({
  selector: 'app-interest-rate-risk-range-popup',
  templateUrl: './interest-rate-risk-range-popup.component.html',
  styleUrls: ['./interest-rate-risk-range-popup.component.scss']
})
export class InterestRateRiskRangePopupComponent implements OnInit {

  DEFAULT_PRODUCT_CATEGORY_VARIANT: any = {
    "F6": {
      "4": 9,
      "6": 6.05,
      "8": 4.09,
      "9": 9
    },
    "F12": {
      "4": 10,
      "6": 6.05,
      "8": 4.09,
      "9": 10
    },
    "F24": {
      "4": 11,
      "6": 7.92,
      "8": 5.56,
      "9": 11
    },
    "F36": {
      "4": 12,
      "6": 9.01,
      "8": 6.12,
      "9": 12
    },
  };

  INTEREST_RATE_RISK_RANGE: any = [
    [
      {

      }
    ]
  ];



  constructor(
    @Inject(MAT_DIALOG_DATA) public matDialogData: DIALOG_DATA,
    private readonly matDialogRef: MatDialogRef<InterestRateRiskRangePopupComponent>
  ) {
    this.matDialogRef = matDialogRef;
   }

  ngOnInit(): void {
  }

  decline(): void {
    this.matDialogRef.close();
  }
}

interface DIALOG_DATA {
  buttonText: string,
  riskScore: RiskScore,
  selectedProduct: string
}
